<cec-dialog
  #dialog
  headerText="{{ 'Speed trial result' | translate }}"
  [subTitle]="stageName"
  [formGroup]="formGroup"
  [disableConfirmButton]="formGroup.invalid"
  (onButtonClicked)="onClickButton($event)"
>
    <form [formGroup]="formGroup">
        <div class="row">
          <div class="select-toggle">
            <cec-select #crew labelKey="Crew number" [options]="crews" formControlName="crewId"></cec-select>
            @if (!id) {
              <mat-slide-toggle [class.hasError]="crew.hasErrors" color="'accent'" (change)="sortCrewNumbers($event)" matTooltip="{{ (sortByRegistration ? 'SortByMath' : 'SortByRegistration') | translate }}"></mat-slide-toggle>
            }
          </div>
          @if ((['xl', 'xxl'] | breakpoint | async)) {
            <cec-input labelKey="Number of bad points" formControlName="points" type="number" [min]="0"></cec-input>
          }
        </div>
        <div class="row">
          <cec-input labelKey="Minutes" formControlName="minutes" type="number" [min]="0"></cec-input>
          <cec-input labelKey="Seconds" formControlName="seconds" type="number" [min]="0" [max]="60"></cec-input>
          <cec-input labelKey="Milliseconds" formControlName="milliseconds" type="number" [min]="0" [max]="999"></cec-input>
          @if ((['xs', 'sm', 'md', 'lg'] | breakpoint | async)) {
            <cec-input labelKey="Number of bad points" formControlName="points" type="number" [min]="0"></cec-input>
          }
        </div>
    </form>
</cec-dialog>